import React, { useEffect, useState } from 'react'
import { AppBar, Button, Container, Toolbar, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useParams, useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { isEqual, cloneDeep } from 'lodash'

import { addStaff } from '../../../actions/Team/team.actions'
import LoadingOverlay from '../../../components/Misc/LoadingOverlay'
import StaffInfoCard from '../../../components/Cards/Staff/StaffInfoCard'

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		paddingTop: '24px',
		paddingLeft: '20px',
		paddingRight: '20px',
		paddingBottom: '75px'
	},
	appBar: {
		top: 'auto',
		bottom: 0,
		paddingRight: '0px !important'
	}
}))

const StaffCreate = () => {
	const classes = useStyles()
	const params = useParams()
	const dispatch = useDispatch()
	const history = useHistory()
	const staffMember = {
		first_name: '',
		last_name: '',
		gender: '',
		active: true,
		email: '',
		deputy_id: '',
		paychex_id: '',
		contact: {
			phone_number: ''
		},
		facility_id: params.facilityId || '',
		market_id: ''
	}
	const loading = useSelector((state) => state.specific.team.loading)
	const facilityId = params.facilityId
	const [current, setCurrent] = useState(staffMember)
	const [isSaveShown, setIsSaveShown] = useState(false)

	useEffect(() => {
		if (params.staffId && staffMember) {
			setCurrent(cloneDeep(staffMember))
		}
	}, [params.staffId, staffMember])

	useEffect(() => {
		if (current && staffMember) {
			let staffEqual = !isEqual(current, staffMember)

			setIsSaveShown(staffEqual)
		}
	}, [current, staffMember])

	const isStaffValid = () => {
		let { first_name, last_name, paychex_id, facility_id, email, contact, apps } = current

		return (
			!first_name || !last_name || !email || !facility_id || !contact || !contact.phone_number || !apps?.length
		)
	}

	const addStaffMember = () => {
		let staffMember = {
			...current,
			full_name: `${current.first_name} ${current.last_name}`
		}

		if (staffMember.contact.phone_number)
			staffMember.contact.phone_number = onlyNumbers(staffMember.contact.phone_number)

		dispatch(addStaff({ ...staffMember }, history, facilityId))
	}

	const clearChanges = () => {
		setCurrent(cloneDeep(staffMember))
	}

	const onlyNumbers = (value) => {
		if (!value || value === '0') return value
		const onlyNums = value.toString().replace(/[^\d]/g, '').replace(/^0+/, '')
		if (onlyNums.length) return onlyNums
		return 0
	}

	return (
		<div>
			{current ? (
				<Container className={classes.root} maxWidth="md">
					<div>
						<Typography variant="h5" style={{ fontWeight: 800, marginBottom: 16 }}>
							{staffMember.full_name}
						</Typography>
						<StaffInfoCard staffMember={current} setCurrent={setCurrent} />
					</div>
					{isSaveShown ? (
						<AppBar position="fixed" color="primary" className={classes.appBar}>
							<Toolbar>
								<Container maxWidth="md">
									<Button
										variant="contained"
										color="secondary"
										disabled={loading || isStaffValid()}
										style={{ marginRight: '8px' }}
										onClick={() => addStaffMember()}>
										ADD TEAMMATE
									</Button>
									<Button variant="outlined" color="secondary" onClick={clearChanges}>
										Cancel
									</Button>
								</Container>
							</Toolbar>
						</AppBar>
					) : null}
				</Container>
			) : null}
			{loading ? <LoadingOverlay /> : null}
		</div>
	)
}

export default StaffCreate
